import Spinner from 'legacy/app/components/help/Spinner';
import useStartPaymentProcessorSession from 'legacy/lib/api/hooks/useStartPaymentProcessorSession';
import { PaymentSessionType } from 'legacy/lib/api/types/PaymentSessionType';
import React from 'react';

const DepositsReport = () => {
	const {
		data: sessionInfo,
		isLoading,
		error,
	} = useStartPaymentProcessorSession(PaymentSessionType.DEPOSITREPORT);

	if (isLoading) {
		return <Spinner isChild />;
	}

	if (error) {
		return null;
	}

	return (
		<rainforest-deposit-report
			show-export-button
			activity-columns={JSON.stringify([
				{ name: 'Created', type: 'builtin', value: 'created_at' },
				{ name: 'Type', type: 'builtin', value: 'type' },
				{ name: 'ID', type: 'builtin', value: 'id' },
				{ name: 'Customer', type: 'builtin', value: 'billing_contact_name' },
				{ name: 'Method', type: 'builtin', value: 'payment_method' },
				{ name: 'Amount', type: 'builtin', value: 'gross_amount' },
				{ name: 'Fees', type: 'builtin', value: 'billing_fees_amount' },
				{ name: 'Net', type: 'builtin', value: 'net_amount' },
				{ name: 'Memo', type: 'builtin', value: 'memo' },
			])}
			session-key={sessionInfo?.sessionKey}
			data-filters={JSON.stringify({
				merchant_id: sessionInfo?.merchantId,
			})}
		/>
	);
};

DepositsReport.displayName = 'DepositsReport';

export default DepositsReport;
